import React from 'react';
import cn from 'classnames';

import { getTranslation } from 'helpers/getTranslation';

import { FormikField } from 'components/FormikField';
import { Typography } from 'components/shared/Typography';

import LessonCategorySelectField from './LessonCategorySelectField';

import styles from './LessonCatalogCategoryField.module.scss';

const LessonCatalogCategoryField = ({
  className,
  labelClassName,
  lessonRole,
  readOnly,
  options,
  loading,
}: {
  className?: string;
  labelClassName?: string;
  lessonRole: any;
  readOnly: any;
  options: { label: string; value: string }[];
  loading: boolean;
}) => {
  if (lessonRole !== 'CATALOG') {
    return null;
  }

  return (
    <div className={cn(styles.root, className)}>
      <Typography
        className={labelClassName}
        variant="body2"
        weight="medium"
        mode="compact"
      >
        {getTranslation('common.text.category')}
      </Typography>
      <div className={styles.selectWrap}>
        <FormikField
          name="categories"
          withControl={false}
          component={LessonCategorySelectField}
          componentProps={{
            options,
            loading,
            readOnly,
            className: styles.select,
            placeholder: getTranslation('common.text.select_categories'),
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(LessonCatalogCategoryField) as any;
